import { fetchUpcomingCourses } from "../util/courses_api_util";

// Types
export const RECEIVE_COURSES = "RECEIVE_COURSES";
export const COURSES_ERROR = "COURSES_ERROR";

// Action creators
export const receiveCourses = (courses) => ({ type: RECEIVE_COURSES, courses });
export const coursesError = (error) => ({ type: COURSES_ERROR, error });

// Thunk

export const getUpcomingCourses = () => async (dispatch) => {
  try {
    const courses = await fetchUpcomingCourses();
    dispatch(receiveCourses(courses));
  } catch (err) {
    dispatch(coursesError(err?.message || "Failed to load courses"));
  }
};
